import React from 'react';
import PropTypes from 'prop-types';
import {TableClickableColumnStyle} from './Table.styled';

export const ClickableElement = React.memo(function TableColumn({children, onClickHandler, href}) {
	/**
	 * Gets the title from the children prop.
	 * @param {string|array} children The children prop which can be a string or array.
	 * @returns {string|null} The title, which will be the children prop if it is a string, or the first element of the array if it is an array.
	 * Returns null if children is not a string or if the first element of the children prop is not a string, otherwise returns a string.
	 */
	const getTitle = children => {
		if (typeof children === 'string') {
			return children;
		}
		if (Array.isArray(children)) {
			return getTitle(children[0]);
		}
		return null;
	};

	return (
		<TableClickableColumnStyle
			data-cy="task-name"
			onKeyDown={onClickHandler ? e => (e.key === ' ' || e.key === 'Enter' ? onClickHandler(e) : null) : null}
			onClick={onClickHandler ? e => onClickHandler(e) : null}
			href={href}
			tabIndex={'0'}
			title={getTitle(children)}
		>
			{children}
		</TableClickableColumnStyle>
	);
});

ClickableElement.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClickHandler: PropTypes.func,
	href: PropTypes.string,
};
